module.exports = __webpack_public_path__ + "img/43.46b44157.jpg";